export default __webpack_public_path__ + "static/media/game-bg.abcfda4b.png";